/*开发环境 */
// 测试网
const dev_home = {
  BASE_API: 'http://localhost:82/',
  REDIRECT_URI:`http://weizhui.xzbfb.com/html#/author`,
  APPID:'wx05d1b0c367fd8b36',
  IMG_BASE_URL:'http://47.93.19.98:20311/'
}

/*外网*/
const prod = {
  BASE_API: 'http://localhost:82/',
  REDIRECT_URI:`http://weizhui.xzbfb.com/html#/author`,
  APPID:'wx05d1b0c367fd8b36',
  IMG_BASE_URL:'http://47.93.19.98:20311/'
}
var innerAudioContext = null;
/*
=================注意根据需要改变环境================
 */
const environment = dev_home;
// const environment = prod;
// const environment = prodh5;

export default {
  REDIRECT_URI: environment.REDIRECT_URI,
  APPID: environment.APPID,
  IMG_BASE_URL:environment.IMG_BASE_URL,
  innerAudioContext : innerAudioContext
}
